import React, { useState } from 'react';

function ContactForm() {
  const [formData, setFormData] = useState({
    phone: '',
    postalCode: '',
    consent: false
  });
  const [showModal, setShowModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setShowSuccess(true);
    setFormData({ phone: '', postalCode: '', consent: false });
  };

  return (
    <>
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label className="block text-gray-900 mb-2">
            Número de teléfono <span className="text-red-500">*</span>
          </label>
          <input
            type="tel"
            placeholder="Número de teléfono"
            value={formData.phone}
            onChange={(e) => setFormData({...formData, phone: e.target.value})}
            className="w-full px-4 py-3 rounded bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#E8C547] border border-black"
            required
          />
        </div>
        
        <div>
          <label className="block text-gray-900 mb-2">
            Código Postal <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="Código Postal"
            value={formData.postalCode}
            onChange={(e) => setFormData({...formData, postalCode: e.target.value})}
            className="w-full px-4 py-3 rounded bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#E8C547] border border-black"
            required
          />
        </div>
      </div>

      <div>
        <h3 className="text-gray-900 font-semibold mb-3">Consentimiento</h3>
        <label className="flex items-start space-x-3 text-gray-900 cursor-pointer">
          <input
            type="checkbox"
            checked={formData.consent}
            onChange={(e) => setFormData({...formData, consent: e.target.checked})}
            className="mt-1 w-5 h-5 accent-[#E8C547]"
            required
          />
          <span>
            Sí, acepto las{' '}
            <button type="button" onClick={() => setShowModal(true)} className="underline hover:text-[#E8C547]">
              políticas de privacidad
            </button>
          </span>
        </label>
      </div>

      <button
        type="submit"
        className="bg-[#E8C547] hover:bg-[#d4b03f] text-[#2D2D2D] font-bold py-3 px-8 rounded transition-colors"
      >
        Enviar
      </button>
    </form>

    {showModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setShowModal(false)}>
        <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" onClick={(e) => e.stopPropagation()}>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-2xl font-bold text-gray-900">Políticas de Privacidad</h3>
            <button onClick={() => setShowModal(false)} className="text-gray-500 hover:text-gray-900 text-2xl">
              ✕
            </button>
          </div>
          <div className="text-gray-700 space-y-4 text-sm">
            <h4 className="font-bold text-lg text-gray-900">Política de Privacidad y Seguridad</h4>
            <p>La siguiente información sobre nuestra Política de Privacidad refleja el compromiso de GEEKFY TELECOM, S.L, (en adelante GEEKFY), como responsable del tratamiento, por mantener y garantizar relaciones comerciales seguras mediante la protección de los datos personales, garantizando el derecho a la privacidad de cada uno de los usuarios de nuestros servicios.</p>
            
            <h5 className="font-bold text-gray-900 mt-4">Definición de dato personal</h5>
            <p>Como «Dato Personal» debemos entender cualquier información concerniente a una persona física identificada o identificable. Entre otros, se incluyen el nombre, apellidos, la dirección postal y electrónica, así como el número de teléfono.</p>
            
            <h5 className="font-bold text-gray-900 mt-4">Tratamientos y finalidades de los datos recogidos</h5>
            <p>Cualquier dato personal que nos facilite al visitar nuestro portal web será tratado de conformidad con las normas de protección de datos y sólo serán recogidos, tratados y utilizados para fines lícitos, legítimos e informados.</p>
            <p><strong>Finalidad:</strong> Poder responder a las consultas planteadas y ponerse en contacto con el usuario para remitirle información comercial sobre energía, servicios de telefonía, servicios de alarma, o seguros, así como ceder sus datos personales a empresas de estos sectores con los que tengamos acuerdos de colaboración.</p>
            <p><strong>Medio:</strong> Las comunicaciones podrán realizarse a través de llamadas telefónicas, SMS o correos electrónicos.</p>
            <p><strong>Legitimación:</strong> La base que legitima el envío de ofertas comerciales por parte de GEEKFY es el consentimiento prestado al facilitar sus datos personales y marcar la casilla correspondiente.</p>
            <p><strong>Plazos de conservación:</strong> Los datos serán conservados durante el tiempo necesario para responder a las cuestiones planteadas, durante un plazo máximo de un año para aquellos supuestos que no deriven en una acción comercial. Para las acciones comerciales, superado el plazo de dos años, el consentimiento tendrá que ser renovado.</p>
            
            <h5 className="font-bold text-gray-900 mt-4">Seguridad de sus datos personales</h5>
            <p>GEEKFY tiene una preocupación especial por garantizar la seguridad de sus datos personales. Sus datos son almacenados en nuestros sistemas de información, donde hemos adoptado e implantado medidas de seguridad, técnicas y organizativas, para prevenir cualquier pérdida o uso no autorizado por terceros.</p>
            
            <h5 className="font-bold text-gray-900 mt-4">Derechos de los usuarios</h5>
            <p>Todos los usuarios pueden ejercitar cualquiera de los derechos otorgados por la normativa de protección de datos, incluyendo el derecho de acceso, rectificación, limitación del tratamiento, supresión, portabilidad de datos y oposición mediante escrito dirigido a Info@geekfy.es</p>
            
            <h5 className="font-bold text-gray-900 mt-4">¿No desea recibir información?</h5>
            <p>Cualquier usuario puede oponerse al uso de su información para fines publicitarios o revocar su consentimiento en cualquier momento enviando un correo electrónico a Info@geekfy.es</p>
            
            <p className="mt-4">Si tiene alguna duda sobre nuestra Política de Privacidad, póngase en contacto con nosotros en Info@geekfy.es</p>
          </div>
          <button onClick={() => setShowModal(false)} className="mt-6 bg-[#E8C547] hover:bg-[#d4b03f] text-[#2D2D2D] font-bold py-2 px-6 rounded transition-colors">
            Cerrar
          </button>
        </div>
      </div>
    )}

    {showSuccess && (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setShowSuccess(false)}>
        <div className="bg-white rounded-lg max-w-md w-full p-8 text-center" onClick={(e) => e.stopPropagation()}>
          <div className="text-green-600 text-6xl mb-4">✓</div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">¡Gracias por tu interés!</h3>
          <p className="text-gray-700 mb-6">Hemos recibido tu solicitud correctamente. Nos pondremos en contacto contigo lo antes posible.</p>
          <button onClick={() => setShowSuccess(false)} className="bg-[#E8C547] hover:bg-[#d4b03f] text-[#2D2D2D] font-bold py-3 px-8 rounded transition-colors">
            Aceptar
          </button>
        </div>
      </div>
    )}
    </>
  );
}

export default ContactForm;
